import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CreateForm from './CreateForm/CreateForm.vue';
import PartnerProgramTable from './PartnerProgramTable/PartnerProgramTable.vue';
import { Ref, ref } from 'vue';
import { ItemType } from '@/types/TableTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerProgram',
  setup(__props) {

const isEdit = ref(false);
const editProgram: Ref<ItemType | undefined> = ref(undefined);

const editPartnerProgram = (partnerProgram: ItemType) => {
  isEdit.value = true;
  editProgram.value = partnerProgram;
};
const cancelEdit = () => {
  isEdit.value = false;
  editProgram.value = undefined;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CreateForm, {
      "edit-program": editProgram.value,
      "is-edit": isEdit.value,
      onCancel: cancelEdit
    }, null, 8, ["edit-program", "is-edit"]),
    _createVNode(PartnerProgramTable, {
      class: "mt--30",
      onEditPartnerProgram: editPartnerProgram
    })
  ], 64))
}
}

})